import { render, staticRenderFns } from "./TooltipButton.vue?vue&type=template&id=1a0710e2&scoped=true&"
import script from "./TooltipButton.vue?vue&type=script&lang=js&"
export * from "./TooltipButton.vue?vue&type=script&lang=js&"
import style0 from "./TooltipButton.vue?vue&type=style&index=0&id=1a0710e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0710e2",
  null
  
)

export default component.exports